import { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router';
import { Spinner } from '@heroui/react';
import { useAuthStore } from '../../stores/authStore';
import { nextQuery } from '../../lib/nextPath';

export default function ProtectedRoute() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const isLoading = useAuthStore((s) => s.isLoading);
  const user = useAuthStore((s) => s.user);
  const loadUser = useAuthStore((s) => s.loadUser);
  const location = useLocation();

  useEffect(() => {
    // On mount, if we have tokens but no user data, fetch the user profile
    if (isAuthenticated && !user && !isLoading) {
      loadUser();
    }
  }, [isAuthenticated, user, isLoading, loadUser]);

  if (!isAuthenticated) {
    // Phase 49 — carry the intended destination through login. The
    // OAuth consent screen encodes its authorization request in the
    // query string, so dropping it strands the third-party app.
    return (
      <Navigate
        to={`/login${nextQuery(location.pathname, location.search)}`}
        replace
      />
    );
  }

  // Block rendering until user profile is loaded — prevents flash of
  // content without user context (TopBar showing undefined, etc.)
  if (isLoading || !user) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Spinner size="lg" />
      </div>
    );
  }

  return <Outlet />;
}
